<template>
  <div class="product">
    <banner img="../assets/img/bgtop.jpg" title="" />
    <div class="product-content" v-loading="loading">
      <div class="p-video">
      </div>
      <div class="lacking">
          <!-- 业务范围 -->
        <div class="lacking-bottom">
          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img wow bounceInLeft" >
              <img src="../assets/test/serve1.png" alt />
            </div>
            <h2>{{$t("message.bitext1")}}</h2>
            <p>{{$t("message.bitext2")}}</p>
            </div>
            
        </div>
        <div class="lacking-bottom">
          <div class="lacking-bottom-item ">
            <div class="lacking-bottom-item-img wow bounceInLeft">
              <img src="../assets/test/serve2.png" alt />
            </div>
            <h2>{{$t("message.bitext3")}}</h2>
            <p>{{$t("message.bitext4")}}</p>
            </div>
        </div>
        <div class="lacking-bottom">
          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img wow bounceInLeft">
              <img src="../assets/test/serve3.png" alt />
            </div>
            <h2>{{$t("message.bitext14")}}</h2>
            <p>{{$t("message.bitext15")}}</p>
            </div>
            
        </div>
        <div class="lacking-bottom">
          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img wow bounceInLeft">
              <img src="../assets/test/serve4.png" alt />
            </div>
            <h2>{{$t("message.bitext16")}}</h2>
            <p>{{$t("message.bitext17")}}</p>
            </div>
        </div>
        <div class="lacking-bottom">
          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img wow bounceInLeft">
              <img src="../assets/test/serve5.png" alt />
            </div>
            <h2>{{$t("message.bitext18")}}</h2>
            <p>{{$t("message.bitext19")}}</p>
            </div>
            
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import { WOW } from 'wowjs';
export default {
  data() {
    return {
      loading: false,
    };
  },
  components: {
    Banner
  },
  created() {
  },
  mounted() {
    //初始化动画
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    })
    wow.init();
  }
};
</script>
<style lang="scss" scoped>

//公司荣誉
.top {
  margin-bottom: 5%;
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}

.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #3c6088;
}

.product {
  width: 100%;
  height: 100%;
  //background-color: #14679f;
  //border: red solid 1px;
  //background: linear-gradient( rgb(36, 143, 243), rgb(221, 166, 95));
  //background-color: #14679f;
}

.product-content {
  width: 1400px;
  margin: 0 auto;
  background-color: #fff;
  height: 1480px;
  //border: red solid 1px;
}

.p-video {
  width: 1000px;
  margin: 0 auto;
  padding: 10px 0;
}

//传统管理模式不足
.lacking {
  height: 420px;
  padding:10px 0;
  margin: 20px 0;
  //border: red solid 1px;
  .lacking-bottom {
    //display: flex;
    //justify-content: space-around;
    padding: 10px 10px;
    border-bottom:2px solid #14679f;
    height: 285px;
    .lacking-bottom-item {
      width: 387px;
      display: inline;
      flex-direction: column;
      align-items: center;
      text-align: center;
      //border: rgb(20, 180, 243) solid 1px;
      .lacking-bottom-item-img {
        width: 387px;
        height: 200px;
        background: #1667a0;
        //border-radius: 5%;
        overflow: hidden;
        line-height: 160px;
        //border: red solid 2px;
        float: left;
        margin-left: 5%;
        margin-top: 30px;
      }
    }
    p {
      font-size: 16px;
      text-align: start;
      margin-left: 38%;
      margin-top: 15px;

    }
    h2 {
      padding: 10px;
      margin-left: 38%;
      margin-top: 3%;
    }
    
  }
}


//
.modular {
  margin-top: 50px;
  .modular-content {
    padding: 50px 50px;
    display: flex;
    justify-content: space-around;
  }
}
.modular-content-same {
  width: 182px;
  height: 405px;

  .same-item {
    height: 70px;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;

    .same-item-img {
      width: 70px;
      height: 70px;
      line-height: 100px;
      background: #1667a0;
      border-radius: 50%;
      text-align: center;
    }
    p {
      color: #1667a0;
      font-weight: 700;
      line-height: 70px;
    }
  }
}

.modular-content-center {
  width: 355px;
  height: 355px;
  img {
    width: 100%;
  }
}
//公共样式
.title,
.eTitle {
  font-size: 34px;
  font-weight: 400;
  color: #333;
  text-align: center;
}
.eTitle {
  font-size: 30px;
  padding: 10px 0;
}

</style>